import { z } from 'zod';

// Zero-fallback: variáveis obrigatórias em falta fazem a app falhar de forma
// explícita no arranque — nunca há valores "mágicos" hardcoded em produção.
const schema = z.object({
  VITE_API_ORIGIN: z.string().url(),
  VITE_CLERK_PUBLISHABLE_KEY: z.string().min(1),
  VITE_ENABLE_MOCKS: z.enum(['true', 'false']).default('false'),
  // Preview privado (Tailscale): arranca sem Clerk (convidado) e sem bloquear no
  // tema — para inspeção da UI em domínios não autorizados pelo Clerk live.
  VITE_PREVIEW: z.enum(['true', 'false']).default('false'),
  VITE_GOOGLE_MAPS_API_KEY: z.string().optional(),
});

const parsed = schema.safeParse(import.meta.env);
if (!parsed.success) {
  // Falha ruidosa em vez de degradar silenciosamente.
  throw new Error(
    `[env] Configuração inválida:\n${parsed.error.issues
      .map((i) => `  • ${i.path.join('.')}: ${i.message}`)
      .join('\n')}\nCopie .env.example → .env.local e preencha.`,
  );
}

export const env = {
  apiOrigin: parsed.data.VITE_API_ORIGIN,
  clerkPublishableKey: parsed.data.VITE_CLERK_PUBLISHABLE_KEY,
  mocksEnabled: parsed.data.VITE_ENABLE_MOCKS === 'true' && import.meta.env.DEV,
  preview: parsed.data.VITE_PREVIEW === 'true',
  mapsKey: parsed.data.VITE_GOOGLE_MAPS_API_KEY || '',
} as const;
